import * as React from "react";
import { forwardRef } from "react";
const SvgIncoming = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, fill: "none", viewBox: "0 0 12 12", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#57728A", d: "M11.125 0 1.217 9.908v-5.82H0V12h7.911v-1.217h-5.82L12 .875z" }));
const ForwardRef = forwardRef(SvgIncoming);
export { ForwardRef as ReactComponent };
